import React from "react";
import { message, Form, Checkbox, Cascader, Radio, Switch } from "antd";
import styled from "styled-components";

import colors from "constants/palette";
import Button from "components/buttons/Button";
import Upload from "components/buttons/Upload";
import Input from "components/inputs/Input";
import TextEditor from "components/inputs/TextEditor";
import NumberInput from "components/inputs/NumberInput";
import ColorPicker from "components/inputs/ColorPicker";
import Select from "components/inputs/Select";
import Fetch from "components/Fetch";
import { StyledModal } from "components/App/styled";
import Features from "./Features";
import Specs from "./Specs";
import Tags from "./Tags";
import VariableProduct from "./VariableProduct";
import SimpleProduct from "./SimpleProduct";

export default function App({ visible, setVisible, data, reload, oldData }) {
  const [form] = Form.useForm();

  const [loading, setLoading] = React.useState(false);
  const [type, setType] = React.useState(
    oldData?.isVariable ? oldData?.isVariable : 0
  ); //0 simple 1 variable 2 weight
  const [category, setCategory] = React.useState(
    oldData?.category ? oldData.category : null
  );
  const [images, setImages] = React.useState(
    oldData?.data ? JSON.parse(oldData.images) : []
  );
  console.log(oldData?.isVariable);
  const showModal = () => {
    setVisible(true);
  };
  const onCategoryChange = (e) => {
    // setCategory(e.join(","));
    console.log(e);
  };
  console.log("manageProductModal data", data);
  React.useEffect(() => {
    oldData && setImages(JSON.parse(oldData?.images) || []);
    oldData && setType(oldData?.isVariable ? oldData?.isVariable : 0);
  }, [visible, oldData]);

  const onSubmit = (data) => {
    var submitData = {
      ...data,
      images: JSON.stringify(images),
      data: JSON.stringify({
        specs: data?.specs,
        features: data?.features,
        variable: data?.variable,
        color: data?.color,
      }),
      category:
        typeof data?.category === "string"
          ? data?.category
          : data?.category.join("-"),
    };

    // check is off price available::
    if (
      type !== 1 &&
      type !== 3 &&
      submitData?.isOff &&
      !submitData?.off_price
    ) {
      message.error("لطفا قیمت تخفیف را وارد کنید");

      return false;
    }

    if (
      (type === 1 || type === 3) &&
      submitData?.isOff &&
      data?.variable.filter((e) => !e.off_price).length
    ) {
      message.error("لطفا قیمت تخفیف همه موارد را وارد کنید");
      return false;
    }

    if (type === 1 || type === 3) {
      //variable product
      if (submitData?.variable?.length < 2) {
        message.error("لطفا بیشتر از 1 مقدار متغیر وارد کنید");
        return false;
      }

      submitData.price = submitData.variable[0].price;
      if (submitData?.isOff)
        submitData.off_price = submitData.variable[0]?.off_price;
    }

    delete submitData.features;
    delete submitData.specs;
    delete submitData.variable;
    delete submitData.color;

    submitData.isVariable = type;
    delete submitData.type;

    setLoading(true);
    if (!oldData) {
      // new :::::::::::::
      Fetch.post("/products", submitData, (res) => {
        console.log("new product response", res);
        if (res?.id) {
          message.success("با موفقیت اضافه شد");
          cleanForm();
          setVisible(false);
          reload(true);
        } else {
          if (res?.title) {
            message.error(res?.title[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
        setLoading(false);
      });
    } else {
      // update :::::::::
      Fetch.put(`/products/${oldData.id}`, submitData, (res) => {
        console.log("new product response/ UPDATE", res);
        if (res?.ok) {
          message.success("با موفقیت آپدیت شد");
          cleanForm();
          setVisible(false);
          reload(true);
        } else {
          if (res?.title) {
            message.error(res.title[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
        setLoading(false);
      });
    }
  };

  console.log("sortedCategories", data.sortedCategories);
  const filter = (inputValue, path) =>
    path.some(
      (option) =>
        option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    );
  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    setVisible(false);
  };
  const cleanForm = () => {
    form.setFieldsValue({
      title: null,
      stock: null,
      price: null,
      description: null,
    });
    setImages([]);
  };

  if (oldData) {
    form.setFieldsValue(oldData);
  }
  const handleTypeChange = ({ target }) => {
    setType(target.value);
  };
  return (
    <>
      <StyledModal
        getContainer="#root"
        title={oldData ? "به روز رسانی" : " اضافه کردن کالا"}
        visible={visible}
        onOk={onSubmit}
        onCancel={handleCancel}
        closable={false}
        footer={[
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleOk}
            style={{ width: "100%" }}
            color={colors.blue}
          >
            ثبت
          </Button>,
        ]}
        width={1080}
      >
        <Form
          form={form}
          layout="vertical"
          style={{ direction: "rtl" }}
          //   requiredMark={requiredMark}
          onFinish={onSubmit}
        >
          <ColContainer>
            <Col>
              <Label>کد کالا :</Label>
              <Form.Item name="code">
                <NumberInput style={{ width: "100%" }} />
              </Form.Item>
              <Label>عنوان کالا :</Label>
              <Form.Item
                name="title"
                rules={[
                  { required: true, message: "لطفا عنوان را وارد کنید!" },
                ]}
              >
                <Input size="large" placeholder="" />
              </Form.Item>
              <Label>تعداد در انبار :</Label>
              <Form.Item name="stock">
                <NumberInput style={{ width: "100%" }} />
              </Form.Item>
              <Label>دسته بندی :</Label>
              <Form.Item
                name="category"
                defaultValue={oldData?.category ? oldData.category : null}
                rules={[
                  {
                    required: true,
                    message: "لطفا دسته بندی را انتخاب کنید!",
                  },
                ]}
              >
                {data.sortedCategories?.length ? (
                  <Cascader
                    no_default="true"
                    // borderradius="0"
                    options={data.sortedCategories}
                    showSearch={{ filter }}
                    placeholder="جستجو"
                    optionFilterProp="children"
                    onChange={onCategoryChange}
                    // filterOption={(input, option) =>
                    //   option.children
                    //     .toLowerCase()
                    //     .indexOf(input.toLowerCase()) >= 0
                    // }
                    // filterSort={(optionA, optionB) =>
                    //   optionA.children
                    //     .toLowerCase()
                    //     .localeCompare(optionB.children.toLowerCase())
                    // }
                  />
                ) : (
                  <Button
                    color={colors.dark}
                    size="small"
                    style={{ height: 30, width: 160, borderRadius: 4 }}
                    href="/dashboard/settings"
                    onClick={showModal}
                  >
                    اضافه کردن دسته بندی
                  </Button>
                )}
              </Form.Item>
              <Label>برند :</Label>
              <Form.Item
                name="brand"
                defaultValue="0"
                rules={[
                  { required: true, message: "لطفا برند را انتخاب کنید!" },
                ]}
              >
                {data.brands.length ? (
                  <Select
                    no_default="true"
                    borderradius="0"
                    list={data.brands}
                    showSearch
                    placeholder="جستجو"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                  />
                ) : (
                  <Button
                    color={colors.dark}
                    size="small"
                    style={{ height: 30, width: 160, borderRadius: 4 }}
                    href="/dashboard/settings"
                  >
                    اضافه کردن برند
                  </Button>
                )}
              </Form.Item>
              <Form.Item name="color">
                <Label>رنگ ها :</Label>

                <ColorPicker
                  form={form}
                  initialValue={
                    oldData?.data ? JSON.parse(oldData?.data)?.color : null
                  }
                  key={oldData ? oldData.id + "color" : "color-new"}
                />
              </Form.Item>
              <h3>لطفا یکی از انواع محصول را انتخاب کنید :</h3>
              <Radio.Group
                value={type}
                buttonStyle="solid"
                style={{ margin: "16px 0" }}
                onChange={handleTypeChange}
              >
                <Radio.Button value={0} key={1}>
                  ساده
                </Radio.Button>
                <Radio.Button value={1} key={2}>
                  وزن متغیر
                </Radio.Button>
                <Radio.Button value={2} key={3}>
                  فله
                </Radio.Button>
                <Radio.Button value={3} key={4}>
                  سایز متغیر
                </Radio.Button>
              </Radio.Group>

              {type === 0 ? (
                <SimpleProduct
                  key={oldData ? oldData.id + "simple" : "simple-new"}
                />
              ) : type === 1 ? (
                <VariableProduct
                  form={form}
                  initialValue={
                    oldData?.data ? JSON.parse(oldData?.data)?.variable : null
                  }
                  type={type}
                  key={oldData ? oldData.id + "variable" : "variable-new"}
                />
              ) : type === 3 ? (
                <VariableProduct
                  form={form}
                  initialValue={
                    oldData?.data ? JSON.parse(oldData?.data)?.variable : null
                  }
                  type={type}
                  key={oldData ? oldData.id + "variable" : "variable-new"}
                />
              ) : (
                <>
                  <SimpleProduct
                    customLabel="هر کیلوگرم"
                    key={oldData ? oldData.id + "weight" : "weight-new"}
                  />
                  <span>
                    * به ازای هر 1 کیلوگرم تعداد در انبار را وارد کنید
                  </span>
                  <br />
                </>
              )}
              <Form.Item
                defaultValue={true}
                valuePropName="checked"
                name="isOff"
                label="فعال کردن تخفیف :"
              >
                <Switch />
              </Form.Item>
            </Col>

            <Col style={{ textAlign: "start" }}>
              <Form.Item
                defaultValue={true}
                valuePropName="checked"
                name="isSpecial"
                label="محصول ویژه :"
              >
                <Switch />
              </Form.Item>
              <Upload
                maxAllowed={20}
                setImage={setImages}
                addedImages={images.length ? images : []}
                key={oldData ? oldData.id + "upload" : "upload-new"}
                index={() =>
                  setTimeout(() => {
                    return oldData ? oldData.id : 0;
                  }, 100)
                }
              />
              <Features
                form={form}
                initialValue={
                  oldData?.data ? JSON.parse(oldData?.data)?.features : null
                }
                key={oldData ? oldData.id + "features" : "features-new"}
              />
              <Specs
                form={form}
                initialValue={
                  oldData?.data ? JSON.parse(oldData?.data)?.specs : null
                }
                key={oldData ? oldData.id + "specs" : "specs-new"}
              />
              <Tags
                form={form}
                initialValue={oldData?.tags ? oldData.tags : null}
                key={oldData ? oldData.id + "tags" : "tags-new"}
              />
            </Col>
          </ColContainer>
          <Col style={{ textAlign: "start", width: "100%" }}>
            <Label style={{ fontWeight: "bold", fontSize: 16, marginTop: 24 }}>
              توضیحات :
            </Label>
            <Form.Item name="description">
              <TextEditor
                form={form}
                initialValue={oldData?.data ? oldData?.description : null}
                key={oldData?.id ? oldData?.id + "-description" : "description"}
              />
            </Form.Item>
          </Col>
        </Form>
      </StyledModal>
    </>
  );
}
const ColContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;
const Col = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  width: 40%;

  & .ant-collapse-item .ant-collapse-header {
    display: flex;
    align-items: center;

    label > span {
      font-size: 17px;
    }
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;
const Label = styled.label`
  margin-bottom: 10px;
  display: block;
  color: ${colors.dark};
`;
